import Konfig from "../../../../../components/categories/siakad/lms/data_murid/subpage/config-murid-baru/Home";
export default function Home() {
  
  return (
    <Konfig />
  );
}
